export default [{
  path: '/servicos',
  component: {
    name: 'servicosBase',
    template: '<router-view />',
    meta: {
      resource: 'servico',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'servicos',
    component: () => import('@/app-modulo/comuns/servico/ServicoView.vue'),
    meta: {
      resource: 'servico',
      action: 'read',
      navActiveLink: 'servicos',
      pageTitle: 'Cadastro de Serviços',
      breadcrumb: [
        {
          text: 'Serviços',
          to: { name: 'servicos' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-servico',
    component: () => import('@/app-modulo/comuns/servico/shared/components/cadastro/Servico.vue'),
    meta: {
      resource: 'servico',
      action: 'create',
      navActiveLink: 'servicos',
      pageTitle: 'Cadastro de Serviços',
      breadcrumb: [
        {
          text: 'Serviços',
          to: { name: 'servicos' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-servico' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-servico',
    component: () => import('@/app-modulo/comuns/servico/shared/components/cadastro/Servico.vue'),
    meta: {
      resource: 'servico',
      action: 'update',
      navActiveLink: 'servicos',
      pageTitle: 'Cadastro de Serviços',
      breadcrumb: [
        {
          text: 'Serviços',
          to: { name: 'servicos' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-servico' },
          active: true,
        },
      ],
    },
  }],
},
]
